import { gql } from '@apollo/client';

export const EXPORT_TRANSACTIONS = gql`
  mutation ExportTransactions(
    $status: [WalletEntryStatusEnum!]
    $sortBy: WalletEntrySortingParams
    $search: String
    $createdAtFrom: DateTime
    $createdAtTo: DateTime
    $providerId: ID
    $businessId: ID!
    $walletEntriesIds: [ID!]
    $pending: Boolean
  ) {
    exportTransactions(
      status: $status
      sortBy: $sortBy
      search: $search
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
      providerId: $providerId
      businessId: $businessId
      walletEntriesIds: $walletEntriesIds
      pending: $pending
    ) {
      id
    }
  }
`;
